import React, { useContext, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import Amplify from '~/amplify';
import { Loading } from '~/components';
import useIntercom from '~/hooks/useIntercom';
import { RouteComponentProps } from '@reach/router';
import { AuthContext } from '~/root/Auth';

const Logout: React.FC<RouteComponentProps> = () => {
  const client = useApolloClient();
  const intercom = useIntercom();
  const { ensureLogin } = useContext(AuthContext);

  useEffect(() => {
    const logout = async () => {
      await Amplify.Auth.signOut();
      await client.clearStore();

      intercom.logOff();
      ensureLogin();
    };

    void logout();
  }, [client, intercom, ensureLogin]);

  return <Loading />;
};

export default Logout;
